var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParcelsTableUser',{attrs:{"navTabs":_vm.navTabs,"filterGetParams":_vm.filterGetParams,"countFilterParams":_vm.countFilterParams},on:{"filter":_vm.filter,"changeTab":_vm.changeTab,"changeFilter":_vm.changeFilter,"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"reloadTable":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }